
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.25 19.5a.75.75 0 01-.75-.75v-4.5a.75.75 0 01.75-.75h4.5a.75.75 0 01.75.75v4.5a.75.75 0 01-.75.75h-4.5zM18 18v-3h-3v3h3z"}}),_c('path',{attrs:{"d":"M.75 22.5a.75.75 0 010-1.5h.75V10.88l-.306.225a.749.749 0 01-1.049-.162.747.747 0 01.161-1.049l10.363-7.6a2.246 2.246 0 012.661.001L15 3.52V2.25a.75.75 0 01.75-.75h4.5a.75.75 0 01.75.75v5.67l2.693 1.975a.752.752 0 01-.443 1.355.74.74 0 01-.444-.146l-.306-.224V21h.75a.75.75 0 010 1.5H.75zM21 21V9.78l-8.556-6.275a.747.747 0 00-.888 0L3 9.78V21h3v-5.25a2.252 2.252 0 012.25-2.25h1.5A2.252 2.252 0 0112 15.75V21h9zm-10.5 0v-5.25a.75.75 0 00-.75-.75h-1.5a.75.75 0 00-.75.75V21h3zm9-14.18V3h-3v1.62l3 2.2z"}})])
          )
        }
      }
    